<template>
  <div>
    <menu-item
      :item="tab"
      :key="tab.id"
      v-for="tab in tabs"
    />
  </div>
</template>

<script>
import MenuItem from '@/components/menu/MenuItem';
import MenuItemMixin from '@/mixins/MenuItemMixin';

export default {
  name: 'SupplierMenu',

  mixins: [
    MenuItemMixin,
  ],

  components: {
    MenuItem,
  },

  computed: {
    tabs() {
      const tabs = [];
      
      tabs.push(
        {
          active: this.isActive('supplier-dashboard'),
          color: 'blue',
          icon: 'mdi-speedometer',
          to: 'supplier-dashboard',
          title: this.$t('menu.supplier.dashboard'),
        },
        {
          active: this.isActive('supplier-requests'),
          color: 'green',
          icon: 'mdi-trending-up',
          to: 'supplier-insights',
          title: this.$t('menu.supplier.insights'),
        },
        {
          active: this.isActive('supplier-marketplace'),
          color: 'blue',
          icon: 'mdi-shopping',
          to: 'supplier-marketplace',
          title: this.$t('menu.marketplace'),
        }
      );

      return tabs
        .filter(Boolean)
        .filter((t) => !t.hidden);
    },
  },

  methods: {
    onSearch() {
      this.$router.push({ name: 'search' });
    },
  }
}
</script>
